module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_18.png?6619bff61ab76529d6b6092422b78bdf";